module.exports = __webpack_public_path__ + "img/klarna.bec395cf.png";